import { SelectableItem } from '../types/search-select.types';

export const COUNTRIES: SelectableItem[] = [
	{ value: 'AF', displayText: 'COUNTRIES.AF' },
	{ value: 'AX', displayText: 'COUNTRIES.AX' },
	{ value: 'AL', displayText: 'COUNTRIES.AL' },
	{ value: 'DZ', displayText: 'COUNTRIES.DZ' },
	{ value: 'AS', displayText: 'COUNTRIES.AS' },
	{ value: 'VI', displayText: 'COUNTRIES.VI' },
	{ value: 'AD', displayText: 'COUNTRIES.AD' },
	{ value: 'AO', displayText: 'COUNTRIES.AO' },
	{ value: 'AI', displayText: 'COUNTRIES.AI' },
	{ value: 'AQ', displayText: 'COUNTRIES.AQ' },
	{ value: 'AG', displayText: 'COUNTRIES.AG' },
	{ value: 'AR', displayText: 'COUNTRIES.AR' },
	{ value: 'AM', displayText: 'COUNTRIES.AM' },
	{ value: 'AW', displayText: 'COUNTRIES.AW' },
	{ value: 'AU', displayText: 'COUNTRIES.AU' },
	{ value: 'AT', displayText: 'COUNTRIES.AT' },
	{ value: 'AZ', displayText: 'COUNTRIES.AZ' },
	{ value: 'BS', displayText: 'COUNTRIES.BS' },
	{ value: 'BH', displayText: 'COUNTRIES.BH' },
	{ value: 'BD', displayText: 'COUNTRIES.BD' },
	{ value: 'BB', displayText: 'COUNTRIES.BB' },
	{ value: 'BY', displayText: 'COUNTRIES.BY' },
	{ value: 'BE', displayText: 'COUNTRIES.BE' },
	{ value: 'BZ', displayText: 'COUNTRIES.BZ' },
	{ value: 'BJ', displayText: 'COUNTRIES.BJ' },
	{ value: 'BM', displayText: 'COUNTRIES.BM' },
	{ value: 'BT', displayText: 'COUNTRIES.BT' },
	{ value: 'BO', displayText: 'COUNTRIES.BO' },
	{ value: 'BA', displayText: 'COUNTRIES.BA' },
	{ value: 'BW', displayText: 'COUNTRIES.BW' },
	{ value: 'BV', displayText: 'COUNTRIES.BV' },
	{ value: 'BR', displayText: 'COUNTRIES.BR' },
	{ value: 'IO', displayText: 'COUNTRIES.IO' },
	{ value: 'VG', displayText: 'COUNTRIES.VG' },
	{ value: 'BN', displayText: 'COUNTRIES.BN' },
	{ value: 'BG', displayText: 'COUNTRIES.BG' },
	{ value: 'BF', displayText: 'COUNTRIES.BF' },
	{ value: 'BI', displayText: 'COUNTRIES.BI' },
	{ value: 'KH', displayText: 'COUNTRIES.KH' },
	{ value: 'CM', displayText: 'COUNTRIES.CM' },
	{ value: 'CA', displayText: 'COUNTRIES.CA' },
	{ value: 'KY', displayText: 'COUNTRIES.KY' },
	{ value: 'CF', displayText: 'COUNTRIES.CF' },
	{ value: 'TD', displayText: 'COUNTRIES.TD' },
	{ value: 'CL', displayText: 'COUNTRIES.CL' },
	{ value: 'CN', displayText: 'COUNTRIES.CN' },
	{ value: 'CX', displayText: 'COUNTRIES.CX' },
	{ value: 'CC', displayText: 'COUNTRIES.CC' },
	{ value: 'CO', displayText: 'COUNTRIES.CO' },
	{ value: 'KM', displayText: 'COUNTRIES.KM' },
	{ value: 'CD', displayText: 'COUNTRIES.CD' },
	{ value: 'CK', displayText: 'COUNTRIES.CK' },
	{ value: 'CR', displayText: 'COUNTRIES.CR' },
	{ value: 'HR', displayText: 'COUNTRIES.HR' },
	{ value: 'CU', displayText: 'COUNTRIES.CU' },
	{ value: 'CW', displayText: 'COUNTRIES.CW' },
	{ value: 'CY', displayText: 'COUNTRIES.CY' },
	{ value: 'CZ', displayText: 'COUNTRIES.CZ' },
	{ value: 'DK', displayText: 'COUNTRIES.DK' },
	{ value: 'DJ', displayText: 'COUNTRIES.DJ' },
	{ value: 'DM', displayText: 'COUNTRIES.DM' },
	{ value: 'DO', displayText: 'COUNTRIES.DO' },
	{ value: 'TL', displayText: 'COUNTRIES.TL' },
	{ value: 'EC', displayText: 'COUNTRIES.EC' },
	{ value: 'EG', displayText: 'COUNTRIES.EG' },
	{ value: 'SV', displayText: 'COUNTRIES.SV' },
	{ value: 'GQ', displayText: 'COUNTRIES.GQ' },
	{ value: 'ER', displayText: 'COUNTRIES.ER' },
	{ value: 'EE', displayText: 'COUNTRIES.EE' },
	{ value: 'ET', displayText: 'COUNTRIES.ET' },
	{ value: 'FK', displayText: 'COUNTRIES.FK' },
	{ value: 'FO', displayText: 'COUNTRIES.FO' },
	{ value: 'FJ', displayText: 'COUNTRIES.FJ' },
	{ value: 'FI', displayText: 'COUNTRIES.FI' },
	{ value: 'FR', displayText: 'COUNTRIES.FR' },
	{ value: 'GF', displayText: 'COUNTRIES.GF' },
	{ value: 'PF', displayText: 'COUNTRIES.PF' },
	{ value: 'TF', displayText: 'COUNTRIES.TF' },
	{ value: 'GA', displayText: 'COUNTRIES.GA' },
	{ value: 'GM', displayText: 'COUNTRIES.GM' },
	{ value: 'GE', displayText: 'COUNTRIES.GE' },
	{ value: 'DE', displayText: 'COUNTRIES.DE' },
	{ value: 'GH', displayText: 'COUNTRIES.GH' },
	{ value: 'GI', displayText: 'COUNTRIES.GI' },
	{ value: 'GR', displayText: 'COUNTRIES.GR' },
	{ value: 'GL', displayText: 'COUNTRIES.GL' },
	{ value: 'GD', displayText: 'COUNTRIES.GD' },
	{ value: 'GP', displayText: 'COUNTRIES.GP' },
	{ value: 'GU', displayText: 'COUNTRIES.GU' },
	{ value: 'GT', displayText: 'COUNTRIES.GT' },
	{ value: 'GG', displayText: 'COUNTRIES.GG' },
	{ value: 'GN', displayText: 'COUNTRIES.GN' },
	{ value: 'GW', displayText: 'COUNTRIES.GW' },
	{ value: 'GY', displayText: 'COUNTRIES.GY' },
	{ value: 'HT', displayText: 'COUNTRIES.HT' },
	{ value: 'HM', displayText: 'COUNTRIES.HM' },
	{ value: 'HN', displayText: 'COUNTRIES.HN' },
	{ value: 'HK', displayText: 'COUNTRIES.HK' },
	{ value: 'HU', displayText: 'COUNTRIES.HU' },
	{ value: 'IS', displayText: 'COUNTRIES.IS' },
	{ value: 'IN', displayText: 'COUNTRIES.IN' },
	{ value: 'ID', displayText: 'COUNTRIES.ID' },
	{ value: 'IR', displayText: 'COUNTRIES.IR' },
	{ value: 'IQ', displayText: 'COUNTRIES.IQ' },
	{ value: 'IE', displayText: 'COUNTRIES.IE' },
	{ value: 'IM', displayText: 'COUNTRIES.IM' },
	{ value: 'IL', displayText: 'COUNTRIES.IL' },
	{ value: 'IT', displayText: 'COUNTRIES.IT' },
	{ value: 'CI', displayText: 'COUNTRIES.CI' },
	{ value: 'JM', displayText: 'COUNTRIES.JM' },
	{ value: 'JP', displayText: 'COUNTRIES.JP' },
	{ value: 'JE', displayText: 'COUNTRIES.JE' },
	{ value: 'JO', displayText: 'COUNTRIES.JO' },
	{ value: 'KZ', displayText: 'COUNTRIES.KZ' },
	{ value: 'KE', displayText: 'COUNTRIES.KE' },
	{ value: 'KI', displayText: 'COUNTRIES.KI' },
	{ value: 'KP', displayText: 'COUNTRIES.KP' },
	{ value: 'KR', displayText: 'COUNTRIES.KR' },
	{ value: 'XK', displayText: 'COUNTRIES.XK' },
	{ value: 'KW', displayText: 'COUNTRIES.KW' },
	{ value: 'KG', displayText: 'COUNTRIES.KG' },
	{ value: 'LA', displayText: 'COUNTRIES.LA' },
	{ value: 'LV', displayText: 'COUNTRIES.LV' },
	{ value: 'LB', displayText: 'COUNTRIES.LB' },
	{ value: 'LS', displayText: 'COUNTRIES.LS' },
	{ value: 'LR', displayText: 'COUNTRIES.LR' },
	{ value: 'LY', displayText: 'COUNTRIES.LY' },
	{ value: 'LI', displayText: 'COUNTRIES.LI' },
	{ value: 'LT', displayText: 'COUNTRIES.LT' },
	{ value: 'LU', displayText: 'COUNTRIES.LU' },
	{ value: 'MO', displayText: 'COUNTRIES.MO' },
	{ value: 'MG', displayText: 'COUNTRIES.MG' },
	{ value: 'MW', displayText: 'COUNTRIES.MW' },
	{ value: 'MY', displayText: 'COUNTRIES.MY' },
	{ value: 'MV', displayText: 'COUNTRIES.MV' },
	{ value: 'ML', displayText: 'COUNTRIES.ML' },
	{ value: 'MT', displayText: 'COUNTRIES.MT' },
	{ value: 'MH', displayText: 'COUNTRIES.MH' },
	{ value: 'MQ', displayText: 'COUNTRIES.MQ' },
	{ value: 'MR', displayText: 'COUNTRIES.MR' },
	{ value: 'MU', displayText: 'COUNTRIES.MU' },
	{ value: 'YT', displayText: 'COUNTRIES.YT' },
	{ value: 'MX', displayText: 'COUNTRIES.MX' },
	{ value: 'FM', displayText: 'COUNTRIES.FM' },
	{ value: 'MD', displayText: 'COUNTRIES.MD' },
	{ value: 'MC', displayText: 'COUNTRIES.MC' },
	{ value: 'MN', displayText: 'COUNTRIES.MN' },
	{ value: 'ME', displayText: 'COUNTRIES.ME' },
	{ value: 'MS', displayText: 'COUNTRIES.MS' },
	{ value: 'MA', displayText: 'COUNTRIES.MA' },
	{ value: 'MZ', displayText: 'COUNTRIES.MZ' },
	{ value: 'MM', displayText: 'COUNTRIES.MM' },
	{ value: 'NA', displayText: 'COUNTRIES.NA' },
	{ value: 'NR', displayText: 'COUNTRIES.NR' },
	{ value: 'NP', displayText: 'COUNTRIES.NP' },
	{ value: 'NL', displayText: 'COUNTRIES.NL' },
	{ value: 'AN', displayText: 'COUNTRIES.AN' },
	{ value: 'NC', displayText: 'COUNTRIES.NC' },
	{ value: 'NZ', displayText: 'COUNTRIES.NZ' },
	{ value: 'NI', displayText: 'COUNTRIES.NI' },
	{ value: 'NE', displayText: 'COUNTRIES.NE' },
	{ value: 'NG', displayText: 'COUNTRIES.NG' },
	{ value: 'NU', displayText: 'COUNTRIES.NU' },
	{ value: 'NF', displayText: 'COUNTRIES.NF' },
	{ value: 'MK', displayText: 'COUNTRIES.MK' },
	{ value: 'MP', displayText: 'COUNTRIES.MP' },
	{ value: 'NO', displayText: 'COUNTRIES.NO' },
	{ value: 'OM', displayText: 'COUNTRIES.OM' },
	{ value: 'PK', displayText: 'COUNTRIES.PK' },
	{ value: 'PW', displayText: 'COUNTRIES.PW' },
	{ value: 'PS', displayText: 'COUNTRIES.PS' },
	{ value: 'PA', displayText: 'COUNTRIES.PA' },
	{ value: 'PG', displayText: 'COUNTRIES.PG' },
	{ value: 'PY', displayText: 'COUNTRIES.PY' },
	{ value: 'PE', displayText: 'COUNTRIES.PE' },
	{ value: 'PH', displayText: 'COUNTRIES.PH' },
	{ value: 'PN', displayText: 'COUNTRIES.PN' },
	{ value: 'PL', displayText: 'COUNTRIES.PL' },
	{ value: 'PT', displayText: 'COUNTRIES.PT' },
	{ value: 'PR', displayText: 'COUNTRIES.PR' },
	{ value: 'QA', displayText: 'COUNTRIES.QA' },
	{ value: 'RE', displayText: 'COUNTRIES.RE' },
	{ value: 'RO', displayText: 'COUNTRIES.RO' },
	{ value: 'RU', displayText: 'COUNTRIES.RU' },
	{ value: 'RW', displayText: 'COUNTRIES.RW' },
	{ value: 'BL', displayText: 'COUNTRIES.BL' },
	{ value: 'KN', displayText: 'COUNTRIES.KN' },
	{ value: 'LC', displayText: 'COUNTRIES.LC' },
	{ value: 'MF', displayText: 'COUNTRIES.MF' },
	{ value: 'PM', displayText: 'COUNTRIES.PM' },
	{ value: 'SX', displayText: 'COUNTRIES.SX' },
	{ value: 'VC', displayText: 'COUNTRIES.VC' },
	{ value: 'WS', displayText: 'COUNTRIES.WS' },
	{ value: 'SM', displayText: 'COUNTRIES.SM' },
	{ value: 'ST', displayText: 'COUNTRIES.ST' },
	{ value: 'SA', displayText: 'COUNTRIES.SA' },
	{ value: 'SN', displayText: 'COUNTRIES.SN' },
	{ value: 'RS', displayText: 'COUNTRIES.RS' },
	{ value: 'SC', displayText: 'COUNTRIES.SC' },
	{ value: 'SL', displayText: 'COUNTRIES.SL' },
	{ value: 'SG', displayText: 'COUNTRIES.SG' },
	{ value: 'SK', displayText: 'COUNTRIES.SK' },
	{ value: 'SI', displayText: 'COUNTRIES.SI' },
	{ value: 'SB', displayText: 'COUNTRIES.SB' },
	{ value: 'SO', displayText: 'COUNTRIES.SO' },
	{ value: 'ZA', displayText: 'COUNTRIES.ZA' },
	{ value: 'GS', displayText: 'COUNTRIES.GS' },
	{ value: 'SS', displayText: 'COUNTRIES.SS' },
	{ value: 'ES', displayText: 'COUNTRIES.ES' },
	{ value: 'LK', displayText: 'COUNTRIES.LK' },
	{ value: 'SH', displayText: 'COUNTRIES.SH' },
	{ value: 'SR', displayText: 'COUNTRIES.SR' },
	{ value: 'SJ', displayText: 'COUNTRIES.SJ' },
	{ value: 'SZ', displayText: 'COUNTRIES.SZ' },
	{ value: 'SE', displayText: 'COUNTRIES.SE' },
	{ value: 'CH', displayText: 'COUNTRIES.CH' },
	{ value: 'SY', displayText: 'COUNTRIES.SY' },
	{ value: 'TW', displayText: 'COUNTRIES.TW' },
	{ value: 'TJ', displayText: 'COUNTRIES.TJ' },
	{ value: 'TZ', displayText: 'COUNTRIES.TZ' },
	{ value: 'TH', displayText: 'COUNTRIES.TH' },
	{ value: 'TG', displayText: 'COUNTRIES.TG' },
	{ value: 'TK', displayText: 'COUNTRIES.TK' },
	{ value: 'TO', displayText: 'COUNTRIES.TO' },
	{ value: 'TT', displayText: 'COUNTRIES.TT' },
	{ value: 'TN', displayText: 'COUNTRIES.TN' },
	{ value: 'TR', displayText: 'COUNTRIES.TR' },
	{ value: 'TM', displayText: 'COUNTRIES.TM' },
	{ value: 'TC', displayText: 'COUNTRIES.TC' },
	{ value: 'TV', displayText: 'COUNTRIES.TV' },
	{ value: 'UG', displayText: 'COUNTRIES.UG' },
	{ value: 'UA', displayText: 'COUNTRIES.UA' },
	{ value: 'AE', displayText: 'COUNTRIES.AE' },
	{ value: 'UK', displayText: 'COUNTRIES.UK' },
	{ value: 'US', displayText: 'COUNTRIES.US' },
	{ value: 'UM', displayText: 'COUNTRIES.UM' },
	{ value: 'UY', displayText: 'COUNTRIES.UY' },
	{ value: 'UZ', displayText: 'COUNTRIES.UZ' },
	{ value: 'VU', displayText: 'COUNTRIES.VU' },
	{ value: 'VA', displayText: 'COUNTRIES.VA' },
	{ value: 'VE', displayText: 'COUNTRIES.VE' },
	{ value: 'VN', displayText: 'COUNTRIES.VN' },
	{ value: 'WF', displayText: 'COUNTRIES.WF' },
	{ value: 'EH', displayText: 'COUNTRIES.EH' },
	{ value: 'YE', displayText: 'COUNTRIES.YE' },
	{ value: 'ZM', displayText: 'COUNTRIES.ZM' },
	{ value: 'ZW', displayText: 'COUNTRIES.ZW' },
];

export const embargoCountries: SelectableItem[] = [
	{ value: 'AF', displayText: 'COUNTRIES.AF' },
	{ value: 'AM', displayText: 'COUNTRIES.AM' },
	{ value: 'AZ', displayText: 'COUNTRIES.AZ' },
	{ value: 'BY', displayText: 'COUNTRIES.BY' },
	{ value: 'CF', displayText: 'COUNTRIES.CF' },
	{ value: 'CG', displayText: 'COUNTRIES.CG' },
	{ value: 'CU', displayText: 'COUNTRIES.CU' },
	{ value: 'ER', displayText: 'COUNTRIES.ER' },
	{ value: 'GE', displayText: 'COUNTRIES.GE' },
	{ value: 'HT', displayText: 'COUNTRIES.HT' },
	{ value: 'IR', displayText: 'COUNTRIES.IR' },
	{ value: 'IQ', displayText: 'COUNTRIES.IQ' },
	{ value: 'KZ', displayText: 'COUNTRIES.KZ' },
	{ value: 'KP', displayText: 'COUNTRIES.KP' },
	{ value: 'KG', displayText: 'COUNTRIES.KG' },
	{ value: 'LB', displayText: 'COUNTRIES.LB' },
	{ value: 'LY', displayText: 'COUNTRIES.LY' },
	{ value: 'MN', displayText: 'COUNTRIES.MN' },
	{ value: 'MM', displayText: 'COUNTRIES.MM' },
	{ value: 'RU', displayText: 'COUNTRIES.RU' },
	{ value: 'SO', displayText: 'COUNTRIES.SO' },
	{ value: 'SD', displayText: 'COUNTRIES.SD' },
	{ value: 'SY', displayText: 'COUNTRIES.SY' },
	{ value: 'TJ', displayText: 'COUNTRIES.TJ' },
	{ value: 'TM', displayText: 'COUNTRIES.TM' },
	{ value: 'UZ', displayText: 'COUNTRIES.UZ' },
	{ value: 'VE', displayText: 'COUNTRIES.VE' },
	{ value: 'YE', displayText: 'COUNTRIES.YE' },
	{ value: 'ZW', displayText: 'COUNTRIES.ZW' },
];

export function excludeCountries(countries: SelectableItem[], excludedCountries: SelectableItem[]): SelectableItem[] {
	const excludedValues = new Set(excludedCountries.map((country) => country.value));

	return countries.filter((country) => !excludedValues.has(country.value));
}

export const AVAILABLE_COUNTRIES = excludeCountries(COUNTRIES, embargoCountries);

/** Returns all countries */
export function getCountries(): SelectableItem[] {
	return [...AVAILABLE_COUNTRIES]; // return a copy to avoid mutation
}

/** Returns only country values (codes) */
export function getCountryValues(): string[] {
	return AVAILABLE_COUNTRIES.map((c) => String(c.value));
}
